import { render, staticRenderFns } from "./card-meuspedidos.vue?vue&type=template&id=b2c49752&scoped=true"
import script from "./card-meuspedidos.vue?vue&type=script&lang=js"
export * from "./card-meuspedidos.vue?vue&type=script&lang=js"
import style0 from "./card-meuspedidos.vue?vue&type=style&index=0&id=b2c49752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c49752",
  null
  
)

export default component.exports